const t = "Tryck på Tab för att gå till popover", r = {
  triggerHint: t
};
export {
  r as default,
  t as triggerHint
};
